// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/resource/seek/button.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XSeek_XSeek__3Ko6M {
  background: rgb(5, 5, 5);
  background: linear-gradient(0deg, rgb(5, 5, 5) 0%, rgb(101, 101, 101) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#050505",endColorstr="#656565",GradientType=1);
  border-radius: 0px 0px 6px 6px;
  padding-left: 12px;
  padding-top: 8px;
  padding-right: 12px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: row;
}
.XSeek_XSeek__3Ko6M button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 24px;
  width: 24px;
  border: 0;
  border-style: none;
  border-width: 0;
  outline-width: 1px;
  outline-style: solid;
  outline-color: black;
  border-radius: 2px;
}
.XSeek_XSeek__3Ko6M button:hover {
  outline-color: white;
}
.XSeek_XSeek__3Ko6M button:focus {
  outline-color: rgb(29, 124, 204);
}
.XSeek_XSeek__3Ko6M button:active {
  outline-color: gray;
}
.XSeek_XSeek__3Ko6M div {
  width: 12px;
  height: 24px;
}
.XSeek_XSeek__3Ko6M input {
  background: rgb(29, 124, 204);
  background: linear-gradient(0deg, rgb(29, 124, 204) 0%, rgb(67, 235, 247) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#1d7ccc",endColorstr="#43ebf7",GradientType=1);
  width: auto;
  height: 24px;
  border: 0;
  border-style: none;
  border-width: 0;
  outline-width: 1px;
  outline-style: solid;
  outline-color: black;
  border-radius: 2px;
  text-indent: 5px;
  text-decoration: none;
  margin: 0;
  padding: 0;
  color: #FFFFFF;
  flex: 1 1;
}
.XSeek_XSeek__3Ko6M input:hover {
  outline-color: white;
}
.XSeek_XSeek__3Ko6M input:focus {
  outline-color: rgb(29, 124, 204);
  box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2) inset;
}`, "",{"version":3,"sources":["webpack://./src/X/styles/XSeek.module.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EAGA,2EAAA;EACA,gHAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;AAAJ;AACI;EACI,yDAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;AACR;AAAQ;EACI,oBAAA;AAEZ;AAAQ;EACI,gCAAA;AAEZ;AAAQ;EACI,mBAAA;AAEZ;AACI;EACI,WAAA;EACA,YAAA;AACR;AACI;EACI,6BAAA;EAGA,+EAAA;EACA,gHAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;AACR;AAAQ;EACI,oBAAA;AAEZ;AAAQ;EACI,gCAAA;EAGA,uDAAA;AAEZ","sourcesContent":[".XSeek {\n    background: rgb(5,5,5);\n    background: -moz-linear-gradient(0deg, rgba(5,5,5,1) 0%, rgba(101,101,101,1) 100%);\n    background: -webkit-linear-gradient(0deg, rgba(5,5,5,1) 0%, rgba(101,101,101,1) 100%);\n    background: linear-gradient(0deg, rgba(5,5,5,1) 0%, rgba(101,101,101,1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#050505\",endColorstr=\"#656565\",GradientType=1);\n    border-radius: 0px 0px 6px 6px;\n    padding-left: 12px;\n    padding-top: 8px;\n    padding-right: 12px;\n    padding-bottom: 8px;\n    //height: 40px;\n    display: flex;\n    flex-direction: row;\n    button {\n        background-image: url(../../../public/resource/seek/button.png);\n        height: 24px;\n        width: 24px;\n        border: 0;\n        border-style: none;\n        border-width: 0;\n        outline-width: 1px;\n        outline-style: solid;\n        outline-color: black;\n        border-radius: 2px;\n        &:hover {\n            outline-color: white;\n        }\n        &:focus {\n            outline-color: rgb(29,124,204);\n        }\n        &:active {\n            outline-color: gray;\n        }\n    }\n    div {\n        width: 12px;\n        height: 24px;\n    }\n    input {\n        background: rgb(29,124,204);\n        background: -moz-linear-gradient(0deg, rgba(29,124,204,1) 0%, rgba(67,235,247,1) 100%);\n        background: -webkit-linear-gradient(0deg, rgba(29,124,204,1) 0%, rgba(67,235,247,1) 100%);\n        background: linear-gradient(0deg, rgba(29,124,204,1) 0%, rgba(67,235,247,1) 100%);\n        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#1d7ccc\",endColorstr=\"#43ebf7\",GradientType=1);\n        width: auto;\n        height: 24px;\n        border: 0;\n        border-style: none;\n        border-width: 0;\n        outline-width: 1px;\n        outline-style: solid;\n        outline-color: black;\n        border-radius: 2px;\n        text-indent: 5px;\n        text-decoration: none;\n        margin: 0;\n        padding: 0;\n        color: #FFFFFF;\n        flex: 1;    \n        &:hover {\n            outline-color: white;\n        }\n        &:focus {\n            outline-color: rgb(29,124,204);\n            -webkit-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2) inset;\n            -moz-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2) inset;\n            box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2) inset;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XSeek": `XSeek_XSeek__3Ko6M`
};
export default ___CSS_LOADER_EXPORT___;
